import axios from 'axios'
import { constants } from '@/constants'
const createAxiosInstance = (baseURL: string) => {
  const instance = axios.create({
    baseURL,
    timeout: Number(localStorage.getItem('exceedTimeout') ?? 55000)
  })

  instance.interceptors.request.use(
    (configParam) => {
      const idToken = sessionStorage.getItem('id_token')
      configParam.headers.Authorization = idToken
      configParam.headers['x-market'] = 'RO'

      const language = localStorage.getItem('lang')
      if (language) {
        configParam.params = { language, ...configParam.params }
      } else {
        const languageValue = constants.application.defaulLang
        localStorage.setItem('lang', languageValue)
        configParam.params = { languageValue, ...configParam.params }
      }
      return configParam
    },
    (error) => {
      return Promise.reject(error)
    }
  )
  localStorage.setItem('exceedTimeout', '')
  return instance
}
// Creating instances for services to be called, for now the suffixes are hardcoded.

// QA env

export const cdcServiceAPI = createAxiosInstance(constants.api.cdcService)
export const magnoliaServiceAPI = createAxiosInstance(constants.api.magnoliaService)
export const generalServiceAPI = createAxiosInstance(constants.api.generalservice)
export const generalServiceAPIV2 = createAxiosInstance(constants.api.generalserviceV2)
// TODO change the API suffixes for some variables to support more countries (enviroments) in API management
